import React from 'react';
import { Button, DatePicker, Form, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import type { QueryFilter } from '../hooks/usePW2501Query';

interface QueryParamsProps {
  filter: QueryFilter;
  loading: boolean;
  onFilterChange: (f: QueryFilter) => void;
  onSearch: () => void;
}

const QueryParams: React.FC<QueryParamsProps> = ({ filter, loading, onFilterChange, onSearch }) => {
  return (
    <Form layout="inline" size="small">
      <Form.Item label="入庫日期起">
        <DatePicker
          data-contract-field="query_date_from"
          value={filter.dateFrom ? dayjs(filter.dateFrom) : null}
          onChange={(d) => onFilterChange({ ...filter, dateFrom: d ? d.format('YYYY-MM-DD') : '' })}
          style={{ width: 130 }}
          placeholder="起始日期"
        />
      </Form.Item>
      <Form.Item label="入庫日期迄">
        <DatePicker
          data-contract-field="query_date_to"
          value={filter.dateTo ? dayjs(filter.dateTo) : null}
          onChange={(d) => onFilterChange({ ...filter, dateTo: d ? d.format('YYYY-MM-DD') : '' })}
          style={{ width: 130 }}
          placeholder="結束日期"
        />
      </Form.Item>
      <Form.Item label="廠商起">
        <Input
          data-contract-field="query_vendor_from"
          value={filter.vendorFrom}
          onChange={(e) => onFilterChange({ ...filter, vendorFrom: e.target.value })}
          placeholder="起始代碼"
          style={{ width: 100 }}
          onPressEnter={onSearch}
        />
      </Form.Item>
      <Form.Item label="廠商迄">
        <Input
          data-contract-field="query_vendor_to"
          value={filter.vendorTo}
          onChange={(e) => onFilterChange({ ...filter, vendorTo: e.target.value })}
          placeholder="結束代碼"
          style={{ width: 100 }}
          onPressEnter={onSearch}
        />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={onSearch}
          loading={loading}
        >
          查詢
        </Button>
      </Form.Item>
    </Form>
  );
};

export default QueryParams;
